import { render, staticRenderFns } from "./WorkShiftListField.vue?vue&type=template&id=795df20c&scoped=true&"
import script from "./WorkShiftListField.vue?vue&type=script&lang=js&"
export * from "./WorkShiftListField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795df20c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('795df20c')) {
      api.createRecord('795df20c', component.options)
    } else {
      api.reload('795df20c', component.options)
    }
    module.hot.accept("./WorkShiftListField.vue?vue&type=template&id=795df20c&scoped=true&", function () {
      api.rerender('795df20c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/fields/WorkShiftListField.vue"
export default component.exports